module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/lowell-6c07d5210d807aaaf99d775d948dd16d.png";